import * as React from "react";
import { useTranslation } from "react-i18next";

import AddInventory from "../../../components/ShopOwner/Inventory/AddInventory";
import CommonContainer from "../../../components/common/container/CommonContainer";

const AddInventoryPage: React.FC<{}> = () => {
    const { t } = useTranslation("translation");

    return (
        <>
            <CommonContainer title={t("addInventoryPageTitle")} description={t("addInventoryPageDescription")} backButtonurl="/shopOwner/fetchInventories">
                <AddInventory />
            </CommonContainer>
        </>
    )
};

export default AddInventoryPage;